module.exports = __webpack_public_path__ + "assets/img/LTC007.49a8aa4a.png";